const region = "us-east-1";
const origin = window.location.origin;

const demo = {
  appSettingsData: {
    // generate a file format limit of video file
    federatedEngageAIProvider: "wl-demo-engage-translate-idp",
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: region,
      userPoolId: "us-east-1_z566MdACX",
      userPoolWebClientId: "26cj8h07vb8sjl08c8mpdqcvcc",
    },
    oauth: {
      domain: "wl-demo-engage-translate.auth.us-east-1.amazoncognito.com",
      scope: [],
      redirectSignIn: `${origin}/documents`,
      redirectSignOut: `${origin}/documents`,
      responseType: "code",
      clientId: "26cj8h07vb8sjl08c8mpdqcvcc",
    },
    API: {
      endpoints: [
        {
          name: "engage-translate",
          // endpoint: "https://api.dev.wl-dms.com",
          endpoint: "https://api.demo.translate.wl-engage.com",
          region: region,
        },
      ],
    },
  },
};
// type demoType = typeof demo

export type DemoType = typeof demo;
export default demo;
